'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular
  .module('systemOwnerReviewControllers')

  .controller('SystemOwnerReviewCompletedController', [
    '$scope',
    '$state',
    '$translate',
    'topBar',
    'nextProcessStep',
    function ($scope, $state, $translate, topBar, nextProcessStep) {
      $scope.nextProcessStep = nextProcessStep;

      $translate('iam.admin.systemOwnerReview.pageTitle').then(function (translation) {
        topBar.setTitle(translation);
      });

      $scope.goToConfirmSystemOwnershipReadOnly = function () {
        if ($scope.nextProcessStep.IsConfirmSystemOwnership) return;

        $state.go(
          'systemOwnerReview.authUser.confirmSystemOwnership',
          {
            authLogin: $scope.authLogin,
          },
          {
            reload: true,
          }
        );
      };

      $scope.goToReviewUniquePermissionsReadOnly = function () {
        if ($scope.nextProcessStep.IsReviewUniquePermissions) return;

        $state.go(
          'systemOwnerReview.authUser.reviewUniquePermissions',
          {
            authLogin: $scope.authLogin,
          },
          {
            reload: true,
          }
        );
      };

      $scope.newIamUrl = environment.iamUrl;
    },
  ]);
